import React from "react";

const BS5_ProgressBars = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_ProgressBars Component</h2>
      <p>This is the BS5_ProgressBars component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_ProgressBars;
